import { render, staticRenderFns } from "./TradeOrderConfirmation.vue?vue&type=template&id=da787bb6&"
import script from "./TradeOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./TradeOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports